import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { EfaactDataService } from '../../efaact.data-service';
import { FeeOnGA } from './fee-on-ga.model';

export const entityName = 'FeeonGAtype';

@Injectable()
export class FeeOnGADataService extends EfaactDataService<FeeOnGA> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: FeeOnGA): FeeOnGA {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.FeeonGAtypeid
        };
    }
}
